import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class ContractExpenditurePerformApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'contract-expenditure-perform'
  }


}
